const config = {
  api() {
    const defaultApiUrl =
      config.env() === "prod"
        ? "https://api.midastrackr.com/api/"
        : "https://hml-api.midastrackr.com/api/";

    return window.midastrackr.apiUrl || defaultApiUrl;
  },
  env() {
    return window.midastrackr.env || "prod";
  },
  defaultAction() {
    return window.midastrackr.defaultAction || "click";
  },
  isBot() {
    return new RegExp(
      [
        "google-adwords",
        "google web preview",
        "google-structured-data",
        "appengine-google",
        "feedfetcher-google",
        "adsbot-google",
        "googlebot",
        "facebookexternalhit",
        "bingbot",
        "msnbot",
        "bingpreview",
        "pinterestbot",
        "google-read-aloud",
        "petalbot",
        "ahrefsbot",
        "adidxbot",
        "brightbot",
        "cloudflare-alwaysonline"
      ].join("|"),
      "i"
    ).test(navigator.userAgent);
  }
};

export { config };
